module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplates) ? _c('mission-slot-template-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplatesPageCount > 1),
      expression: "missionSlotTemplatesPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionSlotTemplatesPaginate",
    attrs: {
      "pageCount": _vm.missionSlotTemplatesPageCount,
      "initial-page": 0,
      "clickHandler": _vm.missionSlotTemplatesPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'missionSlotTemplateCreator'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot.template')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingMissionSlotTemplates
    },
    on: {
      "click": function($event) {
        _vm.missionSlotTemplatesPaginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingMissionSlotTemplates
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c159b68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateList.vue
// module id = 491
// module chunks = 0